import React from 'react';
import { Helmet } from 'react-helmet-async';

import faviconUrl from 'src/assets/favicon/favicon.png';
import { OG as OG_TEXTS } from 'src/constants/other';

interface Props {
  seo?: {
    title?: string;
    description?: string;
  };
  og?: {
    title?: string;
    description?: string;
    imageUrl?: string;
  };
  children?: React.ReactNode;
}

const Head = (props: Props) => {
  const { seo, og } = props;
  const domain = !!(typeof window !== 'undefined' && window.document) ? window.location.href : '';
  const SEO = { title: OG_TEXTS.mainPage.title, description: OG_TEXTS.mainPage.description, ...seo };
  const OG = {
    title: OG_TEXTS.mainPage.title,
    description: OG_TEXTS.mainPage.description,
    ...og,
    imageUrl: `${process.env.WEBSITE_DOMAIN_URL}/static/share-img-2.jpg`,
  };

  return (
    <Helmet>
      <title>{SEO.title}</title>
      <meta name="description" content={SEO.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={domain} />
      <meta property="og:site_name" content="Mako" />
      <meta property="og:locale" content="he_IL" />
      <meta property="og:title" content={OG.title} />
      <meta property="og:description" content={OG.description} />
      <meta property="og:image" content={OG.imageUrl} />
      <link rel="icon" type="image/png" href={faviconUrl} />
      {props.children}
    </Helmet>
  );
};

export default Head;
